
export default {
  // Step wizard keys
  informationStep: "Information",
  locationStep: "Location",
  timeStep: "Date",
  contentStep: "Content",
  accountStep: "Account",
  paymentStep: "Payment",
  submitCampaign: "Submit Campaign",
  next: "Next",
  back: "Back",
  selectLocationDesc: "Choose the locations for your campaign",
  selectDurationDesc: "Choose how long you want your campaign to run",
  uploadCreativesDesc: "Upload your creative assets for the campaign",
  enterAccountInfoDesc: "Enter your company and contact information",
  reviewCampaignDesc: "Review your campaign details",
  information: "Information",
  locations: "Locations",
  time: "Time",
  content: "Content",
  payment: "Payment",
  clickToReturn: "Click to return",
  reviewAndPayment: "Review & Payment",
  proceedToPayment: "Proceed to Payment",
  processing: "Processing...",
  viewInvoice: "View Invoice",
  creatingCampaign: "Creating Campaign...",
  createNewCampaign: "Create New Campaign",
  Error: "Error",
  submissionError: "Submission Error",
  submissionInProgress: "Submission in progress...",
  clickAgain: "Click again to confirm submission",
  
  campaignStart: "Start Date",
  campaignEnd: "End Date",
  
  // Terms and Conditions
  termsTitle: "Terms and Conditions",
  cancel: "Cancel",
  acceptAndProceed: "Accept & Proceed",
} as const;
